import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { SensorTypeConfig } from 'src/app/_shared/models/sensor-type-config';
import { SensorTypesService } from 'src/app/public-utility/sensor-types/services/sensor-types.service';
import { ApiService } from 'src/app/_core/services/api/api.service';
import { Sensor } from 'src/app/_shared/models/sensor';
import { SensorService } from 'src/app/_shared/services/sensor.service';

export interface SensorStateIndicatorConfigurationCreateResolverResult {
  sensorTypeConfigs: SensorTypeConfig[];
  sensors: Sensor[];
}

@Injectable({
  providedIn: 'root',
})
export class SensorStateIndicatorConfigurationCreateResolver
  implements
    Resolve<void | SensorStateIndicatorConfigurationCreateResolverResult> {
  constructor(
    private sensorTypesService: SensorTypesService,
    private sensorService: SensorService,
    private apiService: ApiService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<void | SensorStateIndicatorConfigurationCreateResolverResult> {
    const promises = [];
    promises.push(this.sensorTypesService.getSensorTypeConfigs(false));
    promises.push(this.sensorService.getSensors(0, 100, false));
    return Promise.all(promises)
      .then((result) => {
        return {
          sensorTypeConfigs: result[0],
          sensors: result[1],
        };
      })
      .catch((err) => {
        this.apiService.handleError(err);
        throw err;
      });
  }
}
